import { makeAutoObservable, runInAction } from 'mobx';
import { Organization } from '../shared/models/Organization';
import { OrganizationService } from '../services/OrganizationService';

export class OrganizationDetailViewModel {
  organization: Organization | null = null;
  loading = false;
  error: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  async load(id: string, organization?: any) {
    // 如果已经传入了机构信息，直接使用
    if (organization) {
      runInAction(() => {
        this.organization = organization;
        this.loading = false;
        this.error = null;
      });
      return;
    }

    // 否则从服务器加载
    this.loading = true;
    this.error = null;
    try {
      const org = await OrganizationService.getOrganizationById(id);
      runInAction(() => {
        this.organization = org;
        this.loading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err instanceof Error ? err.message : '加载机构详情失败';
        this.loading = false;
      });
    }
  }

  reset() {
    this.organization = null;
    this.loading = false;
    this.error = null;
  }
}


